package team.platforma.multiplatform_material_extension.calendar.utils

import androidx.compose.animation.core.AnimationEndReason
import androidx.compose.runtime.Composable
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import kotlinx.coroutines.CoroutineScope


@Composable
internal fun rememberAnimatedMonthChange(): AnimatedMonthChange {
    return remember { AnimatedMonthChangeImpl() }
}

internal interface AnimatedMonthChange {
    fun onFadeoutEnd(result: () -> Unit)
    fun addListener(listener: AnimatedMonthChangeListener)
    fun removeListener(listener: AnimatedMonthChangeListener)
}

internal interface AnimatedMonthChangeListener {
    fun fadeout(animationEnd:() -> Unit)
}

private class AnimatedMonthChangeImpl() : AnimatedMonthChange {

    private val listeners = mutableListOf<AnimatedMonthChangeListener>()
    override fun onFadeoutEnd(result: () -> Unit) {
        listeners.forEach {
               it.fadeout {
                   result.invoke()
               }
        }
    }

    override fun addListener(listener: AnimatedMonthChangeListener) {
        listeners.add(listener)
    }

    override fun removeListener(listener: AnimatedMonthChangeListener) {
        listeners.remove(listener)
    }

}

